import { render, staticRenderFns } from "./Grade10.vue?vue&type=template&id=3d0d4c88&scoped=true&"
import script from "./Grade10.vue?vue&type=script&lang=js&"
export * from "./Grade10.vue?vue&type=script&lang=js&"
import style0 from "./Grade10.vue?vue&type=style&index=0&id=3d0d4c88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0d4c88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VContainer,VLayout,VSlideYTransition})
